/**
 * Route for `ai-powered-fraud-algorithms`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AiPoweredFraudAlgorithmsPage } from "../features/ai-powered-fraud-algorithms/AiPoweredFraudAlgorithmsPage";

export const aiPoweredFraudAlgorithmsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/ai-powered-fraud-algorithms",
	component: AiPoweredFraudAlgorithmsPage,
});

export default aiPoweredFraudAlgorithmsRoute;
